"use client"
  import __i18nConfig from '@next-translate-root/i18n'
  import AppDirI18nProvider from 'next-translate/AppDirI18nProvider'
  import { useSearchParams as __useSearchParams, useParams as __useParams } from 'next/navigation'
  import { use as __use, Suspense as __Suspense } from 'react'
  import __loadNamespaces from 'next-translate/loadNamespaces'

  ;
import { useRouter } from "next/navigation";
import errorGif from "@/assets/images/decorators/404.gif";
import CustomButton from "@/common/customElements/button";
import { NEUTRO_TITLES_COLOR, PRIMARY_BUTTON_COLOR } from "@/utils/constants";
const ErrorPage = () => {
    const router = useRouter();
    return (<div style={{
            display: "flex",
            width: "100%",
            height: "calc(100vh)",
            justifyContent: "space-around",
            alignItems: "center",
            position: "relative",
            flexDirection: "column",
        }}>
      <p style={{
            color: NEUTRO_TITLES_COLOR,
            fontSize: "46px",
            fontWeight: "600",
            textAlign: "center",
            marginBottom: "0px",
        }}>
        Parece que ha ocurrido un error
      </p>
      <img src={errorGif.src} width={550} alt="error_gif"/>
      <CustomButton onClick={() => router.back()} width="250px" height="50px" backgroundColor={PRIMARY_BUTTON_COLOR}>
        <p style={{
            color: NEUTRO_TITLES_COLOR,
            fontSize: "16px",
            fontWeight: "500",
            marginBottom: "0px",
        }}>
          Volver
        </p>
      </CustomButton>
    </div>);
};
const __Next_Translate__Page__195f094baf7__ = ErrorPage;


  export default function __Next_Translate_new__195f094baf7__(props) {
    const searchParams = __useSearchParams()
    const params = __useParams()
    const detectedLang = params.lang ?? searchParams.get('lang')

    if (detectedLang === 'favicon.ico') return <__Next_Translate__Page__195f094baf7__ {...props} />

    

    const lang = detectedLang ?? __i18nConfig.defaultLocale
    const config = {
      ...__i18nConfig,
      locale: lang,
      loaderName: 'client /page',
      pathname: '/[lng]/[...not-found]/',
    }

    return (
      <__Suspense fallback={null}>
        <__Next_Translate__child__195f094baf7__ 
          {...props} 
          config={config} 
          promise={__loadNamespaces({ ...config, loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})), })}
         />
      </__Suspense>
    )
  }

  function __Next_Translate__child__195f094baf7__({ promise, config, ...props }) {
    const { __lang, __namespaces } = __use(promise);
    const oldNamespaces = globalThis.__NEXT_TRANSLATE__?.namespaces ?? {};
    globalThis.__NEXT_TRANSLATE__ = { lang: __lang, namespaces: { ...oldNamespaces, ...__namespaces }, config };
    return <__Next_Translate__Page__195f094baf7__ {...props} />;
  }
